import React from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import {
  Canvas2D
} from 'troika-2d'
import StreamArea from './StreamArea'

class TimelineImpl2D extends React.PureComponent {
  static displayName = "Schemer.TimelineImpl2D"

  static propTypes = {
    height: T.number,
    width: T.number,

    xScale: T.any,
    yScale: T.any,
    colorScale: T.any,
    minX: T.number,
    maxX: T.number,
    minY: T.number,
    maxY: T.number,
    renderData: IT.list,

    xFields: IT.orderedMap,
    xFieldKeys: IT.listOf(T.string),
    yFields: IT.orderedMap,
    yFieldKeys: IT.listOf(T.string),
    yFieldKeysToStyles: IT.map,
    colorFields: IT.orderedMap,
    colorFieldKeys: IT.list,
    activeXFieldKey: T.string,
    activeYFieldKeys: IT.list,
    activeColorFieldKey: T.string,

    selectedXFieldKey: T.string,
    selectedYFieldKeys: IT.list,
    selectedColorFieldKey: T.string,

    pathInterpolate: T.string,
    xExponent: T.number,

    minYForceZero: T.bool,

    onPathMouseOver: T.func,
    onPathMouseOut: T.func,
    onPathMouseMove: T.func,
    highlightedPathKey: T.string,
  }

  render() {
    const {
      height,
      width,

      xScale,
      yScale,
      minX,
      maxX,
      minY,
      maxY,
      renderData,
      yFieldKeysToStyles,
      pathInterpolate,
      // xExponent,
      minYForceZero,
      onPathMouseOver,
      onPathMouseOut,
      onPathMouseMove,
      highlightedPathKey
    } = this.props

    if (!renderData || !height || !width) {
      return <div className="schemer_timeline no_data" />
    }

    return (
      <Canvas2D
        width={width}
        height={height}
        objects={{
          key: 'main',
          facade: StreamArea,

          // crisp edges
          x: 0.5,
          y: 0.5,

          xScale,
          yScale,
          renderData,
          minX,
          maxX,
          minY,
          maxY,

          yFieldKeysToStyles,
          pathInterpolate,

          onPathMouseOver,
          onPathMouseOut,
          onPathMouseMove,
          highlightedPathKey,
          minYForceZero
        }}
      />
    )
  }
}

export default TimelineImpl2D